"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulationPaymentSerialization = void 0;
class SimulationPaymentSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        return copy;
    }
}
exports.SimulationPaymentSerialization = SimulationPaymentSerialization;
